import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Col, Row} from "react-bootstrap";

import {Link} from 'react-router-dom';
import {loadGeneralEnum} from '../actions/enums';
import {countUsers, loadUsers} from '../actions/users';
import {showModal} from "../actions/modal";
import {resetPage, showMessage} from '../actions';
import {defaultState} from '../reducers/paginate';
import Users from '../components/user/Users';
import {Acl, breadcrumbs} from "../utils";

class UsersPage extends Component {

	constructor(props) {
		super(props);

		this.handleFetchData = this.handleFetchData.bind(this);
		this.handleFetchEnums = this.handleFetchEnums.bind(this);
	}

	componentDidMount() {
	}

	componentWillUnmount() {
		this.props.resetPage();
	}

	handleFetchEnums(enums, filter = {}) {
		for (const i in enums) {
			if (enums.hasOwnProperty(i)) {
				this.props.loadGeneralEnum(enums[i], filter)
			}
		}
	}

	handleFetchData(filter) {
		this.props.loadUsers(filter);
		this.props.countUsers(filter);
	}

	render() {
		const {page, enums, session} = this.props;

		return (
			<div>
				<Row>
					<Col xs={8}>
						{breadcrumbs([{title: 'users'}])}
					</Col>
					<Col xs={4}>
						{Acl.isAllowed(session, Acl.right.USER_NEW_GLOBAL, Acl.right.USER_NEW_CLUB) &&
						<Link to={{pathname: "/users/new"}} className="btn btn-success pull-right"><span className="fa fa-plus"/> Nový</Link>}
					</Col>
				</Row>
				<Users {...page} enums={enums} session={session}
					onFetchEnums={this.handleFetchEnums}
					onFetchData={this.handleFetchData}
					onShowModal={this.props.showModal}
					onShowMessage={this.props.showMessage}
				/>
			</div>
		)
	}
}

UsersPage.propTypes = {
	page: PropTypes.object,
	enums: PropTypes.object,
	loadGeneralEnum: PropTypes.func.isRequired,
	loadUsers: PropTypes.func.isRequired,
	countUsers: PropTypes.func.isRequired,
	showMessage: PropTypes.func.isRequired,
	resetPage: PropTypes.func.isRequired,
	session: PropTypes.object.isRequired,
	showModal: PropTypes.func.isRequired
};


const mapStateToProps = (state, ownProps) => {
	const {
		pagination: {users},
		enums,
		session
	} = state;

	const page = users[0] || defaultState;

	return {
		page,
		enums,
		session
	}
};

export default connect(mapStateToProps, {
	loadGeneralEnum,
	loadUsers,
	countUsers,
	showMessage,
	resetPage,
	showModal
})(UsersPage)
